import React, {useState, useEffect, Fragment} from 'react'

// Material-UI Core
import {makeStyles, withStyles} from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Box from '@material-ui/core/Box'
import Tooltip from '@material-ui/core/Tooltip'
import Fab from '@material-ui/core/Fab'
import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'
import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'

// Material-UI Icon
import AddIcon from '@material-ui/icons/Add'
import DeleteIcon from '@material-ui/icons/Delete'
import GroupIcon from '@material-ui/icons/Group'
import LaunchIcon from '@material-ui/icons/Launch'

// Custom Component
import {getUserGroup} from '../../dataSource/userGroup'

// Custom Style
import {userGroupListStyle} from '../../styles/jss/components/userGroup/userGroupListStyle'


// Custom Style (Typography)
const ResultMsgTypography = withStyles({
	root: {
		"fontSize": 15,
		"fontWeight": 600,
		"color": "red",
	},
}) (Typography)


const useStyles = makeStyles(theme => userGroupListStyle(theme))

const UserGroupList = props => {
	const classes = useStyles()
	const {typeSeq, userGroupFormDialogHandleOpen, deleteGroupActionConfirmOpen, userGroupListRefresh, getUserListLoading} = props

	const [userGroupList, setUserGroupList] = useState(null)
	const [resultMsg, setResultMsg] = useState("")


	useEffect(() => {
		getUserGroup(typeSeq).then(res => {
			setUserGroupList(res.data)

			if (res.data.length > 0) {
				setResultMsg("")
			}
			else {
				setResultMsg("No Group Record")
			}
		})

	}, [userGroupListRefresh])

	return (
		// console.log("User Group List | Variable: userGroupList (UserGroupList.js)"),
		// console.log(userGroupList),
		
		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<Paper >
				<div className={classes.groupListArea}>
					{getUserListLoading}
					<List>
						{
							userGroupList !== null ?
								userGroupList.length > 0 ?
									userGroupList.map(res => {
										return (
											<div key={res.group_seq}>
												<ListItem>
													<ListItemAvatar>
														<Avatar>
															<GroupIcon />
														</Avatar>
													</ListItemAvatar>

													<ListItemText
														primary={res.group_name}
														secondary={res.group_description}
													/>
														<ListItemSecondaryAction>

															<Tooltip title="Modify Group">
																<Fab color="primary" size="small" aria-label="launch" className={classes.groupListBtn} onClick={userGroupFormDialogHandleOpen(typeSeq, res)}>
																	<LaunchIcon />
																</Fab>
															</Tooltip>

															<Tooltip title="Delete Group">
																<Fab color="primary" size="small" aria-label="delete" className={classes.groupListBtn} onClick={deleteGroupActionConfirmOpen(res.group_seq)}>
																	<DeleteIcon />
																</Fab>
															</Tooltip>
															
														</ListItemSecondaryAction>
												</ListItem>
												<Divider className={classes.divider} />
											</div>
										)
									})
								: <div className={classes.resultMsg}><ResultMsgTypography>{resultMsg}</ResultMsgTypography></div>
							: <div className={classes.resultMsg}><ResultMsgTypography>{resultMsg}</ResultMsgTypography></div>
						}
					</List>
				</div>

				<Box className={classes.addGroupBtnArea}>
					<Tooltip title="Create Group">
						<Fab color="primary" size="small" aria-label="add_new_group" className={classes.addGroupBtn} onClick={userGroupFormDialogHandleOpen(typeSeq, null)}>
							<AddIcon />
						</Fab>
					</Tooltip>
				</Box>
			</Paper>
		</Fragment>
	)
}


export default UserGroupList